<template>
  <div id="company">
  <section>
    <h3><span class="h3_line"><span class="h3_deco"></span>{{myTopCategory.name}}</span></h3>
    <div v-for="child in myTopCategory.child" v-bind:key="child.id">
      <h4>{{child.name}}</h4>
      <div class="speclist">
        <img :src="categoryImage[child.id]" :alt="child.name" @error="setNoImage(child.id)">
        <ul v-if="child.child.length > 0">
          <li v-for="children in child.child" v-bind:key="children.id">
            <router-link :to="{name: 'list', params: {Id: children.id}}">{{children.name}}</router-link>
          </li>
        </ul>
        <ul v-else>
          <li>
            <router-link :to="{name: 'list', params: {Id: child.id}}">{{child.name}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        categoryImages: [],
        sortCategories: [],
        myTopCategory: [
          {
            'id': null,
            'name': null,
            'image': '',
            'child': [
              {
                'id': null,
                'name': null,
                'child': []
              }
            ]
          }
        ],
        categoryImage: {},
        kenki_image_path: process.env.VUE_APP_KENKI_IMAGE_PATH,
        baseUrl: process.env.BASE_URL || '/'
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      if(this.categorySet.length>0){
        this.sortCategories = this.categorySet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.syncBreadcrumbs(this.$route.params.Spec)
      } else {
        this.$parent.category_id = null
        this.$parent.active_page_title = this.$route.params.Spec || ''
      }
    },
    methods: {
      setNoImage: function (category_id) {
        this.categoryImage[category_id] = this.baseUrl + 'img/noimage.png'
      },
      syncBreadcrumbs: function (fallbackName) {
        var title = this.myTopCategory && this.myTopCategory.name ? this.myTopCategory.name : fallbackName
        this.$parent.category_id = this.myTopCategory ? this.myTopCategory.id : null
        this.$parent.active_page_title = title
        if (this.$root && this.$root.setPageMeta) {
          this.$root.setPageMeta(title)
        }
      },
      kenkiImagePath: function (product_code,n) {
        return this.kenki_image_path + product_code + '-' + ('00' + (n+1)).slice(-2) + '.jpg'
      },
      setMyTopCategory: function (){
        var target = this.myTopCategory
        var targetItems = []
        var specName = this.$route.params.Spec
        targetItems = this.sortCategories.filter(function(item){
          if((item.name).indexOf(specName)>=0) return true
        })
        target = targetItems[0]
        this.myTopCategory = target
        this.syncBreadcrumbs(specName)
      },
      getImagePath: function (category_id, id) {
        var myId = id
        var url = process.env.VUE_APP_URL + '/stock_products/search/'
        var myToken = process.env.VUE_APP_TOKEN
        var myComId = process.env.VUE_APP_COMPANY_ID
        var param = {}
        param = {
          'limit': 100,
          'stock_product': {
              'category_id': myId,
              'company_id': myComId
          }
        }
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
             'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data[0] && data[0].product && data[0].product.product_code) {
            this.categoryImage[category_id] = this.kenkiImagePath(data[0].product.product_code,0)
          } else {
            this.setNoImage(category_id)
          }
        })
        .catch(e => {
          console.error(e)
          this.setNoImage(category_id)
        })
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.syncBreadcrumbs(this.$route.params.Spec)
      }
    }
    
  }
</script>
<style>
.speclist li a:hover {
  color: #000000;
	text-decoration: none;
	background-color: #f1f1f1;
}
</style>
